module.exports = __webpack_public_path__ + "img/corporativ.06d889fc.svg";